/**
 * Moved out of the three apps' global index.css (#18911) — these Cloudinary-hosted `@font-face`
 * rules were previously loaded on every page for every user regardless of whether their
 * presentation contains a Sherwin-Williams section.
 */
export const SHERWIN_WILLIAMS_FONT_FACE_CSS = `
@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849288/paintscout/partners/sw/fonts/FontDropcloth-RegularItalic.ttf')
    format('truetype');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849287/paintscout/partners/sw/fonts/FontDropcloth-Regular.ttf')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849287/paintscout/partners/sw/fonts/FontDropcloth-MediumItalic.ttf')
    format('truetype');
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849286/paintscout/partners/sw/fonts/FontDropclothDisplay-Regular.ttf')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849285/paintscout/partners/sw/fonts/FontDropcloth-Medium.ttf')
    format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849284/paintscout/partners/sw/fonts/FontDropclothDisplay-Light.ttf')
    format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849283/paintscout/partners/sw/fonts/FontDropclothDisplay-Bold.ttf')
    format('truetype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CustomFont-SW';
  src: url('https://res.cloudinary.com/taptapquote/raw/upload/v1709849283/paintscout/partners/sw/fonts/FontDropcloth-Bold.ttf')
    format('truetype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
`
